import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_ENDPOINTS from '../../utils/api';

export const fetchDumpsters = createAsyncThunk(
  'dumpster/fetchDumpsterDetails',
  async ({ slug, page = 1, limit = 3 }) => {
    const response = await axios.get(
      `${API_ENDPOINTS.COMPANY_DUMPSTER_DETAILS(
        slug
      )}?page=${page}&limit=${limit}`
    );
    return response.data;
  }
);

export const fetchSingleDumpster = createAsyncThunk(
  'dumpster/fetchSingleDumpsterDetails',
  async ({ slug, dumpsterId }) => {
    const response = await axios.get(
      API_ENDPOINTS.SINGLE_DUMPSTER_DETAILS(slug, dumpsterId)
    );
    return response.data;
  }
);

const dumpsterSlice = createSlice({
  name: 'dumpsters',
  initialState: {
    dumpsters: [],
    singleCompanyDumpster: null,
    loading: false,
    error: null,
    pagination: {
      currentPage: 1,
      totalPages: 1,
      nextPageUrl: null,
      prevPageUrl: null,
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchDumpsters.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDumpsters.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null; // Reset error on success

        if (!action.payload || !action.payload.data) {
          state.dumpsters = []; // Ensure dumpsters is an empty array
          state.pagination = {
            currentPage: 1,
            totalPages: 1,
            nextPageUrl: null,
            prevPageUrl: null,
            perPage: 25,
            totalItems: 0,
          };
        } else {
          state.dumpsters = action.payload.data;

          // Update pagination state
          state.pagination = {
            currentPage: action.payload.data.dumpster_sizes?.current_page || 1,
            totalPages: action.payload.data.dumpster_sizes?.last_page || 1,
            nextPageUrl:
              action.payload.data.dumpster_sizes?.next_page_url || null,
            prevPageUrl:
              action.payload.data.dumpster_sizes?.prev_page_url || null,
            perPage: action.payload.data.dumpster_sizes?.per_page || 25,
            totalItems: action.payload.data.dumpster_sizes?.total || 0,
          };
        }
      })

      .addCase(fetchDumpsters.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      // Fetch single dumpster (Fix for your issue)
      .addCase(fetchSingleDumpster.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSingleDumpster.fulfilled, (state, action) => {
        state.loading = false;
        state.singleCompanyDumpster = action.payload;
        state.error = null;
      })
      .addCase(fetchSingleDumpster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch dumpster';
      });
  },
});

export const { addDumpster } = dumpsterSlice.actions;
export default dumpsterSlice.reducer;
